














import Vue from "vue";

// Components
import FiltersCard from "@/views/App/CashFlow/UsersBalance/FiltersCard.vue";
import ReportTableCard from "@/views/App/CashFlow/ChannelsBalance/ReportTableCard.vue";
import TotalsCard from "@/views/App/CashFlow/UsersBalance/TotalsCard.vue";

// Model
import menu from "@/store/modules/ApplicationModule/data/menu";
import { GetChannelsBalanceReportCommand } from "@/model/communication/channelsBalance/GetChannelsBalanceReportCommand";
import { GetChannelsBalanceReportReqData } from "@/model/communication/channelsBalance/GetChannelsBalanceReportReqData";
import { GetChannelsBalanceReportResData } from "@/model/communication/channelsBalance/GetChannelsBalanceReportResData";
import { ExportChannelsBalanceCommand } from "@/model/communication/channelsBalance/ExportChannelsBalanceCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ChannelsBalanceReportEntry } from "@/model/data/channelsBalance/ChannelsBalanceReportEntry";

export default Vue.extend({
    components: {
        FiltersCard,
        ReportTableCard,
        TotalsCard,
    },
    data() {
        return {
            filters: null,
            channelsBalanceReportEntries: [],
            channelsBalanceReportTotals: null,
            loading: false,
            analizedTransactionsCount: -1,
        };
    },
    computed: {
        menuEntry() {
            return menu.find((m) => m.name == "Cash Flow").children.find((c) => c.name == "Channels Balance");
        },
    },
    methods: {
        async GetChannelsBalance() {
            try {
                if (!this.loading) {
                    this.loading = true;

                    let res: GetChannelsBalanceReportResData = await new GetChannelsBalanceReportCommand(
                        (this.filters as GetChannelsBalanceReportReqData).GetReqDataPayload()
                    ).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.channelsBalanceReportEntries = this.flattenChannels(res.channelsBalanceReportEntries);
                        this.channelsBalanceReportTotals = res.channelsBalanceReportTotals;
                        this.analizedTransactionsCount = res.analizedTransactionsCount;
                    }
                    this.loading = false;
                }
            } catch (error) {
                console.error("GetChannelsBalance(): ", error);
                this.loading = false;
            }
        },
        async onDownload(exportType) {
            console.log("Download required, exportType: ", exportType);
            try {
                if (!this.loading) {
                    this.loading = true;
                    const res = await new ExportChannelsBalanceCommand((this.filters as GetChannelsBalanceReportReqData).GetReqDataPayload(), exportType).execute();

                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during ExportChannelsBalanceCommand execution: ", e);
                this.loading = false;
            }
        },
        flattenChannels(entries: ChannelsBalanceReportEntry[]) {
            const flatList: ChannelsBalanceReportEntry[] = [];

            function flatten(entry: ChannelsBalanceReportEntry) {
                flatList.push(entry);

                for (const child of entry.children) {
                    flatten(child);
                }
            }

            for (const entry of entries) {
                flatten(entry);
            }

            return flatList;
        },
    },
    mounted() {
        this.filters = new GetChannelsBalanceReportReqData();
    },
});
